import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faBoxTaped } from '@fortawesome/pro-light-svg-icons';

export type ProLightBoxTapedProps = IconComponentProps;

export const ProLightBoxTaped = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightBoxTapedProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faBoxTaped}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faBoxTaped}
    />
  );
};

ProLightBoxTaped.displayName = 'ProLightBoxTaped';
